@if (isVisible) {
  <div
    #modalContainer
    class="modal fade show d-block utility-rates-modal-overlay"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    style="background-color: rgba(0,0,0,0.5);"
    (click)="onBackdropClick($event)">
    <div
      class="modal-dialog modal-xl modal-dialog-scrollable"
      role="document"
      (click)="$event.stopPropagation()">
      <div class="modal-content" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="modal-header">
          <h5 class="modal-title">
            Utility Rates - {{ formatScheduleDisplayName(utilitySchedule) }}
          </h5>
          <button
            type="button"
            class="btn-close"
            (click)="onClose()"
            aria-label="Close">
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label fw-semibold mb-1">Effective Dates</label>
            <select
              class="form-select form-select-sm utility-rates-version-select"
              [ngModel]="getSelectedVersionScheduleId()"
              [disabled]="getIsLoadingRates()"
              (ngModelChange)="onRateVersionChange($event)">
              @for (option of getRateVersionOptions(); track option.label) {
                <option [ngValue]="option.scheduleId">
                  {{ option.label }}
                </option>
              }
            </select>
          </div>

          @if (getIsLoadingRates()) {
            <div class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span class="ms-2">Loading utility rates...</span>
            </div>
          } @else {
            <app-utility-rates-display
              [utilitySchedule]="utilitySchedule"
              [demandRates]="getDemandRates()"
              [energyRates]="getEnergyRates()"
              [readOnly]="readOnly"
              [isLoading]="getIsLoadingRates()"
              [isSavingDemandRates]="getIsSavingDemandRates()"
              [isSavingEnergyRates]="getIsSavingEnergyRates()"
              [isSavingServiceCharges]="getIsSavingServiceCharges()"
              [isSavingOtherCharges]="getIsSavingOtherCharges()"
              [isSavingNotes]="getIsSavingNotes()"
              [scheduleMetadata]="getScheduleMetadata()"
              [autoLoadScheduleMetadata]="false"
              (saveDemandRates)="onSaveDemandRates($event)"
              (saveEnergyRates)="onSaveEnergyRates($event)"
              (saveServiceCharges)="onSaveServiceCharges($event)"
              (saveOtherCharges)="onSaveOtherCharges($event)"
              (saveNotes)="onSaveNotes($event)">
            </app-utility-rates-display>
          }
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="onClose()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-confirmation-modal
    [isVisible]="showDeleteRatesConfirmationModal()"
    [modalData]="deleteRatesModalData()"
    (confirm)="onDeleteRatesConfirm()"
    (cancel)="onDeleteRatesCancel()">
  </app-confirmation-modal>
}
